import { BG_COLOR_CODING_MAP, DEFAULT_BG_COLOR } from './constants';

// Selecting the color coding for the component based on the selected bg color
export const getColorCodings = (selectedColor: string) => {
  return (
    BG_COLOR_CODING_MAP[selectedColor] ?? BG_COLOR_CODING_MAP[DEFAULT_BG_COLOR]
  );
};
